import * as styles from './LegalFooterDisclaimer.css';

const LegalFooterDisclaimer: React.FC = () => (
  <p className={styles.disclaimer}>
    By continuing you agree to our{' '}
    <a
      className={styles.link}
      href="https://blinq.me/legal/privacy-policy"
      target="_blank"
      rel="noreferrer"
    >
      Privacy Policy
    </a>{' '}
    and{' '}
    <a
      className={styles.link}
      href="https://blinq.me/legal/terms-conditions"
      target="_blank"
      rel="noreferrer"
    >
      Terms of Service
    </a>
  </p>
);

export default LegalFooterDisclaimer;
